var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25,6.125 C12.25,9.50774409 9.50774409,12.25 6.125,12.25 C2.74225591,12.25 0,9.50774409 0,6.125 C0,2.74225591 2.74225591,0 6.125,0 C7.749451,0 9.30736872,0.645310647 10.456029,1.79397097 C11.6046894,2.94263128 12.25,4.500549 12.25,6.125 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "black",
    fillRule: "nonzero",
    points: "5.25 2.625 7 2.625 7 7 5.25 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "black",
    fillRule: "nonzero",
    points: "5.25 7.875 7 7.875 7 9.625 5.25 9.625"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationFill);
export default __webpack_public_path__ + "static/media/exclamation-fill.48ed91ea521d906c990beac0600eeb93.svg";
export { ForwardRef as ReactComponent };